import type {CreateSupplierFunctionFormPayload} from "./create-supplier-function.schema";

import {createSupplierFunction} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {supplierFunctionKeys, supplierFunctionMutationKeys} from "../../../supplierFunction-keys";

export function createSupplierFunctionMutationOptions() {
  return mutationOptions({
    mutationFn: (payload: CreateSupplierFunctionFormPayload) => createSupplierFunction(payload),
    mutationKey: supplierFunctionMutationKeys.createSupplierFunction,
    onSuccess: async (_supplierFunctionId, _payload, _context, {client}) => {
      await client.invalidateQueries({queryKey: supplierFunctionKeys.lists()});
    },
  });
}
